<template>
  <v-container fill-height>
    <v-layout row>
      <v-flex xs12 sm2 offset-sm5>
        <v-card>
          <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
          <v-card-text>
            <v-container>
              <h3>Reset Password</h3>
              <form @submit.prevent="forgotPass">
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="email"
                      label="Email Address"
                      id="email"
                      v-model="email"
                      type="email"
                      required></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <div class="text-xs-center">
                    <v-btn  type="submit" :disabled="loading">
                      Send Password Request
                    </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import shared from '../../mixins/shared'

  export default {
    mixin: [shared],
    data () {
      return {
        email: '',
        loading: false
      }
    },
    methods: {
      forgotPass () {
        this.loading = true
        this.$fb.auth().sendPasswordResetEmail(this.email).then(() => {
          this.loading = false
          this.addNotification({text: 'You will recieve an email to reset your password', color: 'success'})
        }).catch((error) => {
          this.addNotification({text: 'An error has occured, contact support', color: 'error'})
          this.loading = false
          console.log(error)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Password.vue?4a2fe05e